import { TAdminAppointmentsResponse } from '@mybonum/api';

import { TAdminAppointmentType } from '../types.ts';

export const normalizeData = (
    data: TAdminAppointmentsResponse['result']
): TAdminAppointmentType[] =>
    data.map((item) => ({
        id: item.id,
        email: item.email,
        firstName: item.first_name,
        lastName: item.last_name,
        phone: item.phone,
        practiceEmail: item.practice_location_email,
        practiceName: item.practice_location_name,
    }));
